import { Component } from '@angular/core';

@Component({
  selector: 'app-parametrage',
  templateUrl: './parametrage.component.html',
  styleUrl: './parametrage.component.css'
})
export class ParametrageComponent {

}
